import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Divider,
  MenuItem,
  Modal,
  TextField,
  Typography
} from '@mui/material';

import LoadingButton from '../../../../../components/buttons/Button';
import useSearchableSelect from '../../../../../components/hooks/useSearchableSelect';

import {
  UpdateAssemblySessionBIZcoreTD
} from '../../../../../redux/actions/business/core/tradeDefencesActions';
import { 
  GetCompaniesDropdownBIZcore 
} from '../../../../../redux/actions/business/core/companiesActions';

import {
  CLEAR_COMPANIES_DROPDOWN_BIZ_CORE
} from '../../../../../redux/actionTypes';

import global from "../../../../../global.scss";

const MODES = { CREATE: 1, EDIT: 2 };

const Data = {
  Company: null,
  IsActive: true,
};

const AssemblySessionModal = ({
  open,
  setOpen,
  title,
  update,
  handleGet
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(Data);
  const [mode, setMode] = useState(MODES.CREATE);

  const {
    results: companyResults,
    loading: companySearchLoading,
    handleSearch: handleCompanySearch,
    reset: resetCompanySearch,
  } = useSearchableSelect(
    GetCompaniesDropdownBIZcore,
    (state) => {
      const list = state["business.core"].companiesDropdownList;
      if (list?.records && Array.isArray(list.records)) {
        return list.records;
      }
      return [];
    },
    null,
    { limit: 10, formatQuery: (q) => `&search=${q}` }
  );

  const handleClose = () => {
    setOpen(false);
    setFormData(Data);
    setMode(MODES.CREATE);
    dispatch({ type: CLEAR_COMPANIES_DROPDOWN_BIZ_CORE });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    try {
      if (open) {
        resetCompanySearch();
        // if (update.defaultMode === MODES.CREATE) {
        //   setMode(MODES.CREATE);
        //   setFormData(Data);
        // } else 
        if (update.defaultMode === MODES.EDIT) {
          setMode(MODES.EDIT);
          setFormData({
            Company: update.ref_company_id || null,
            IsActive: update.is_active !== undefined ? update.is_active : true,
          });
        } else {
          toast.error("Invalid modal");
          handleClose();
        }
      }
    } catch (err) {
      console.log(err);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleSubmit = () => {
    const obj = {
      ref_company_id: formData.Company,
      is_active: formData.IsActive,
    };

    // if (mode === MODES.CREATE) {
    //   dispatch(CreateAssemblySessionBIZcoreTD(obj, setLoading)).then(() => {
    //     handleGet(setLoading).then(() => {
    //       handleClose();
    //     });
    //   });
    // } else 
    if (mode === MODES.EDIT) {
      dispatch(UpdateAssemblySessionBIZcoreTD(update.id, obj, setLoading)).then(() => {
        handleGet(setLoading).then(() => {
          handleClose();
        });
      });
    } else {
      toast.error("Invalid modal");
      handleClose();
    }
  };

  const isSubmitDisabled = !formData.Company || formData.IsActive === "";

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box className="flexCenterCenterRow" width={"100vw"} height={"100vh"}>
        <Box maxWidth={"sm"} className="modal">
          <Box width={"100%"} sx={{ padding: "15px" }}>
            <Typography variant='h6'
              sx={{ color: global["primary"] }} mb={"20px"}>
              {title}
            </Typography>

            {/* Company */}
            <Box mb={"15px"}>
              <Autocomplete
                fullWidth
                options={Array.isArray(companyResults) ? companyResults : []}
                loading={companySearchLoading}
                disabled={mode === MODES.EDIT}
                value={
                  formData.Company
                  ? (Array.isArray(companyResults) ? companyResults : []).find(c => c.id === formData.Company) || formData.Company
                  : null
                }
                onInputChange={(e, value) => handleCompanySearch(value)}
                onChange={(e, value) => setFormData({ ...formData, Company: value?.id || null })}
                getOptionLabel={(option) =>
                  typeof option === 'string'
                  ? option
                  : (option.name || option.id || "NA")
                }
                isOptionEqualToValue={(option, value) => {
                  if (typeof value === 'string') return option.id === value;
                  return option.id === value?.id;
                }}
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    <Typography variant="body2">{option.name || option.id || "NA"}</Typography>
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Company"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {companySearchLoading ? <CircularProgress color="inherit" size={16} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Box>

            {/* Is Active */}
            <Box mb={"15px"}>
              <TextField
                select
                label="Is active"
                fullWidth
                name="IsActive"
                value={formData.IsActive}
                onChange={handleChange}
              >
                <MenuItem value={true}>Yes</MenuItem>
                <MenuItem value={false}>No</MenuItem>
              </TextField>
            </Box>
          </Box>
          <Divider sx={{ backgroundColor: "rgba(44, 45, 47, 1)" }} />
          <Box className="flexCenterFERow" sx={{ gap: "20px", margin: "15px" }}>
            <Button variant='text' onClick={handleClose}>
              Cancel
            </Button>
            <LoadingButton
              variant='contained'
              loading={loading}
              disabled={isSubmitDisabled}
              onClick={handleSubmit}>
              Submit
            </LoadingButton>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default AssemblySessionModal;
